import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../services';

@Injectable()
export class CompanyGuard implements CanActivate {

    constructor(
        private router: Router,
        private userService: UserService
    ) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.userService.getCompany()) {
            return true;
        }
        else {
            this.router.navigate(['/company']);
        }
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/guards/company.guard.ts